export function V3ProblemSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-10 flex-1 min-h-0">
        <div className="flex-1 flex flex-col">
          <h2 className="text-[28px] font-light tracking-tight leading-tight mb-4 font-[family-name:var(--font-heading)]">
            AI is the biggest shift in fifty years.<br />
            Small firms are locked out.
          </h2>
          <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
            The Big 4 spend nine figures a year on internal AI. Small firms, <strong className="font-medium text-[var(--color-fg)]">80% of the market by count</strong>, cannot afford engineers and cannot deploy SaaS tools. They watch the gap widen every quarter.
          </p>
          <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed font-light mt-3">
            Their cost structure is dominated by intelligence work that AI can now do autonomously. <strong className="font-medium text-[var(--color-fg)]">Only judgement needs a human:</strong> the professional&apos;s sign-off. That&apos;s 10-30% of the work.
          </p>

          {/* Stacked bar — anchored to the bottom of the left column, lifted to right column's content bottom */}
          <div className="mt-auto" style={{ marginBottom: "115px" }}>
            <div className="flex w-full h-7 rounded-sm overflow-hidden border border-[var(--color-border)]" style={{ fontVariantNumeric: "tabular-nums" }}>
              <div
                className="flex items-center px-3 gap-2.5 text-white whitespace-nowrap"
                style={{ width: "75%", background: "var(--color-accent)" }}
              >
                <span className="text-[11px] font-bold font-[family-name:var(--font-heading)] leading-none">70-90%</span>
                <span className="text-[8px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.15em] opacity-90">
                  Intelligence work · AI can do this now
                </span>
              </div>
              <div
                className="flex items-center px-3 gap-2.5 whitespace-nowrap"
                style={{ width: "25%", background: "var(--color-surface)" }}
              >
                <span className="text-[11px] font-bold font-[family-name:var(--font-heading)] leading-none text-[var(--color-fg)]">10-30%</span>
                <span className="text-[8px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.15em] text-[var(--color-fg-tertiary)]">
                  Judgement
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-[32%] shrink-0 flex items-start relative pt-0">
          <div className="flex flex-col justify-start w-full pl-10 -my-4 py-4 gap-5 border-l border-[var(--color-border)]">
            {[
              { value: "45-50%", label: "Small-firm overhead spend" },
              { value: "Up to 70%", label: "Costs in back-office tasks" },
              { value: "10-30%", label: "Work that needs a human" },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-[28px] font-light mb-1 font-[family-name:var(--font-heading)]" style={{ fontVariantNumeric: "tabular-nums" }}>
                  {stat.value}
                </div>
                <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
            <div className="border-t border-[var(--color-border)] pt-4 mt-1">
              <p className="text-[9px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider opacity-70 leading-relaxed">
                Source: Sequoia Capital, &ldquo;Services: The New Software&rdquo;, March 2026
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] leading-relaxed">
          <span className="italic">&ldquo;We don&apos;t want another tool. We want the work done.&rdquo;</span>
          <span className="text-[var(--color-fg-tertiary)] ml-2">— Partner, UK immigration firm</span>
        </p>
      </div>
    </div>
  );
}
